/** @format */

import {useAddressForm} from 'frontier/cart/components/addresses/use_address_form';
import FormAddressInput from 'frontier/cart/components/addresses/form_address_input';
import {Drawer, DrawerHeader} from '@sttark/design-system';
import {ErrorDisplay, IfElse} from 'frontier-utilities';
import {InputWithErrorHandler} from 'frontier-form';
import React, {useState, useEffect} from 'react';

// styles
import './form.scss';

export default function UserAccountAddressForm(props) {
    const {userId, isShippingAddress, onClose} = props;

    const {
        onFormUpdate,
        onFormInputChange,
        onFormPhoneInputChange,
        setFormData,
        formData,
        isSaving,
        addressFormErrors,
        setAddressFormErrors,
        onSave
    } = useAddressForm({userId, onSaveComplete: handleSaveComplete});

    const handleOnclose = () => {
        setFormData({});
        onClose();
    };

    function handleSaveComplete() {
        props.onSaveComplete();
        setFormData({});
    }
    // Remove full_name so we can edit first_name and last_name separately
    useEffect(() => {
        setFormData({
            ...props.formData,
            is_shipping_address: isShippingAddress,
            full_name: null,
            name: null
        });
    }, [props]);

    return (
        <Drawer isOpen={props.isOpen} onClose={handleOnclose}>
            <DrawerHeader onClose={handleOnclose}>
                <div className="address-form-49kt__title d-flex align-items-center justify-content-between">
                    <h4 className=" m-0 p-0">
                        {formData.id ? 'Edit' : 'Add'} {isShippingAddress ? 'Shipping' : 'Billing'}{' '}
                        Address
                    </h4>
                    <div className="d-flex align-items-center justify-content-end gap-4">
                        <button className="btn btn--secondary" onClick={handleOnclose}>
                            <b>Cancel</b>
                        </button>
                        <IfElse condition={isSaving}>
                            <button className="btn btn--primary" disabled="disabled">
                                <b>saving...</b>
                            </button>
                            <button className="btn btn--primary" onClick={onSave}>
                                <b>{formData.id ? 'Save' : 'Add'} Address</b>
                            </button>
                        </IfElse>
                    </div>
                </div>
            </DrawerHeader>
            {/* First and Last Name*/}
            <div className="address-form-49kt__body">
                <div className="address-form-49kt-body__name-input">
                    <InputWithErrorHandler
                        value={formData.first_name ?? ''}
                        placeholder="Enter First Name"
                        error={addressFormErrors}
                        errorPath={'first_name'}
                        onChange={onFormInputChange.bind(this, 'first_name')}
                    />
                    <InputWithErrorHandler
                        value={formData.last_name ?? ''}
                        error={addressFormErrors}
                        placeholder="Enter Last Name"
                        errorPath={'last_name'}
                        onChange={onFormInputChange.bind(this, 'last_name')}
                    />
                </div>
                {/* Email and Phone Number*/}
                <div className="address-form-49kt-body__contact-input">
                    <InputWithErrorHandler
                        value={formData.email ?? ''}
                        error={addressFormErrors}
                        errorPath={'email'}
                        placeholder="Enter Email"
                        onChange={onFormInputChange.bind(this, 'email')}
                    />
                    <InputWithErrorHandler
                        value={formData.phone ?? ''}
                        error={addressFormErrors}
                        errorPath={'phone'}
                        placeholder="Enter Phone Number"
                        onChange={onFormPhoneInputChange.bind(this, 'phone')}
                    />
                </div>

                <div className="address-form-49kt-body__address-input">
                    <FormAddressInput
                        defaultAddressLine2={formData.defaultAddressLine2}
                        defaultAddress={formData.formatted_address}
                        defaultCompany={formData.company}
                        onUpdate={onFormUpdate}
                    />
                </div>

                {formData.is_shipping_address && (
                    <InputWithErrorHandler
                        className="form-control form-control-sm"
                        value={formData.proof_email ?? ''}
                        error={addressFormErrors}
                        errorPath={'proof_email'}
                        placeholder={'Enter Proof Email'}
                        onChange={onFormInputChange.bind(this, 'proof_email')}
                    />
                )}
                <div className="mt-4">
                    <ErrorDisplay
                        className="address-form-49kt-body__error-display d-block"
                        error={addressFormErrors}
                    />
                </div>
            </div>
        </Drawer>
    );
}
